// Empfehlungs-Code aus geteilten Links (Teilen v1, T1, Scope 03.11.2026).
//
// `?ref=CODE` wird auf JEDER Seite gelesen (nicht mehr nur auf /schnuppertag) und im
// Arbeitsspeicher der Sitzung gehalten. So geht der Code nicht verloren, wenn jemand über den
// Link auf der Startseite landet und erst später zum Schnuppertag klickt.
// Auf dem Gerät (Cookie cc_ref, 90 Tage, First-Touch) nur mit Statistik-Einwilligung, gleiches
// Muster wie utm_params (Datenstrategie D0, § 25 TDDDG). In der App nie (darfMessungSpeichern).
// Der Code identifiziert nur den Werber pseudonym; gespeichert wird er erst mit der Buchung
// (referral_code_used), wie bisher. Kein Name, kein Foto, nichts vom Werber auf der Seite.
//
// Bewusst ohne weitere Imports außer geraeteSpeicher: das Modul liegt im Einstieg (useUtmCapture).
import { darfMessungSpeichern } from "@/lib/geraeteSpeicher";

/** Format wie im Schnuppertag-Formular und in generate_referral_code(): 2 Buchstaben + 4-5 Zeichen. */
export const REF_MUSTER = /^[A-Z]{2}[A-Z0-9]{4,5}$/;
export const REF_COOKIE = "cc_ref";
const MAX_AGE = 60 * 60 * 24 * 90;

let imSpeicher: string | null = null;

/** Code normalisieren und prüfen; ungültig = null (nie fremden Text übernehmen). */
export function refNormal(wert: string | null | undefined): string | null {
  const t = String(wert ?? "").trim().toUpperCase();
  return REF_MUSTER.test(t) ? t : null;
}

function cookieLesen(): string | null {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${REF_COOKIE}=([^;]*)`));
    return m ? refNormal(decodeURIComponent(m[1])) : null;
  } catch {
    return null;
  }
}

/**
 * `ref` aus der aktuellen Adresse merken (Speicher, mit Einwilligung Cookie). Beim Laden und nach
 * einer Entscheidung im Banner aufrufen (attributionSpeichern). First-Touch: ein gespeicherter
 * Cookie wird nicht überschrieben. Wirft nie.
 */
export function refMerken(): void {
  if (typeof window === "undefined") return;
  try {
    const ausUrl = refNormal(new URLSearchParams(window.location.search).get("ref"));
    if (ausUrl && !imSpeicher) imSpeicher = ausUrl;
    if (imSpeicher && darfMessungSpeichern() && !cookieLesen()) {
      document.cookie = `${REF_COOKIE}=${encodeURIComponent(imSpeicher)}; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
    }
  } catch {
    /* Messung darf nie die Seite stören */
  }
}

/** Gemerkter Code dieser Sitzung bzw. (mit Einwilligung) aus dem Cookie, sonst null. */
export function gemerkterRef(): string | null {
  if (!imSpeicher) refMerken();
  if (imSpeicher) return imSpeicher;
  return darfMessungSpeichern() ? cookieLesen() : null;
}
